<template>
  <div v-if="visible" class="overlay" @click.self="close">
    <div class="modal-box">
      <div class="modal-head">
        <h3 class="modal-title">{{ form.id ? 'Ustani tahrirlash' : 'Yangi usta' }}</h3>
        <button class="close-btn" @click="close">&times;</button>
      </div>
      <div class="modal-body">
        <div class="field-group">
          <label class="flabel">Ism familiya</label>
          <input
            ref="nameInput"
            v-model="form.name"
            type="text"
            class="finput"
            placeholder="Ismi..."
            @keyup.enter="save"
          >
        </div>
        <div class="field-group">
          <label class="flabel">Telefon raqami</label>
          <input
            v-model="form.phone"
            type="text"
            class="finput"
            placeholder="+998 (__) ___ __ __"
            @keyup.enter="save"
          >
        </div>
        <div class="field-group">
          <label class="flabel">Bonus foizi (%)</label>
          <input v-model.number="form.bonus" type="number" class="finput" placeholder="0" min="0" max="100">
        </div>

        <!-- 🎁 Ball tizimi sozlamalari -->
        <div class="ball-card">
          <div class="ball-title">🎁 Ball tizimi (loyalty)</div>
          <div class="ball-help">
            Har <b>{{ ballSummaFmt }}</b> so'm savdo uchun <b>{{ form.ball_amount || 0 }}</b> ball.
            <span v-if="!ballEnabled" class="ball-off">Hozir o'chiq.</span>
          </div>
          <div class="field-row-2">
            <div class="field-group">
              <label class="flabel">Har qancha so'm uchun</label>
              <input v-model.number="form.ball_summa" type="number" class="finput" placeholder="1000000" min="0" step="1000">
            </div>
            <div class="field-group">
              <label class="flabel">Necha ball</label>
              <input v-model.number="form.ball_amount" type="number" class="finput" placeholder="0" min="0" step="0.5">
            </div>
          </div>
        </div>

        <!-- 🔐 Login kodi -->
        <div class="field-group">
          <div class="label-row">
            <label class="flabel">Login kodi (kamida 4 belgi)</label>
            <label class="alpha-toggle">
              <input type="checkbox" v-model="alphanumeric">
              A-z ham ishlatilsin
            </label>
          </div>
          <div class="code-row">
            <input
              v-model="form.login_code"
              type="text"
              class="finput code-input"
              placeholder="4 belgidan kam bo'lmasin"
              :minlength="4"
            >
            <button type="button" class="btn-gen" @click="generateCode" title="Avtomatik kod">
              ⟳ Generatsiya
            </button>
          </div>
          <div class="code-hint" v-if="form.login_code">
            Ustaga ayting: <b>{{ form.login_code }}</b>
          </div>
        </div>
        <!-- Oylik maoshi yashirilgan — default 0 bilan saqlanadi
        <div class="field-group">
          <label class="flabel">Oylik maoshi (so'm)</label>
          <input v-model.number="form.salary" type="number" class="finput" placeholder="0" min="0">
        </div>
        -->

      </div>
      <div class="modal-foot">
        <button class="btn-cancel-m" @click="close">Bekor</button>
        <button class="btn-save-m" @click="save" :disabled="loading">
          {{ loading ? 'Saqlanmoqda...' : 'Saqlash' }}
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import axios from 'axios';

export default {
  name: 'UstaForm',
  props: {
    value:    { type: Boolean, default: false },
    editItem: { type: Object, default: null },
  },
  data() {
    return {
      loading: false,
      alphanumeric: false,
      form: { id: null, name: '', phone: '+998 ', salary: 0, bonus: 0, ball_summa: 0, ball_amount: 0, login_code: '' },
    };
  },
  computed: {
    visible: {
      get() { return this.value; },
      set(v) { this.$emit('input', v); },
    },
    ballEnabled() {
      return Number(this.form.ball_summa) > 0 && Number(this.form.ball_amount) > 0;
    },
    ballSummaFmt() {
      return Number(this.form.ball_summa || 0).toLocaleString('ru-RU').replace(/,/g, ' ');
    },
  },
  watch: {
    value(v) {
      if (v) this.loadFromProp();
    }
  },
  methods: {
    loadFromProp() {
      if (this.editItem && this.editItem.id) {
        this.form = {
          id:          this.editItem.id,
          name:        this.editItem.name || '',
          phone:       this.editItem.phone_number || '+998 ',
          salary:      Number(this.editItem.salary || 0),
          bonus:       Number(this.editItem.bonus  || 0),
          ball_summa:  Number(this.editItem.ball_summa  || 0),
          ball_amount: Number(this.editItem.ball_amount || 0),
          login_code:  this.editItem.login_code || '',
        };
      } else {
        this.form = { id: null, name: '', phone: '+998 ', salary: 0, bonus: 0, ball_summa: 0, ball_amount: 0, login_code: this.randomCode() };
      }
      this.$nextTick(() => setTimeout(() => this.$refs.nameInput && this.$refs.nameInput.focus(), 200));
    },
    close() { this.visible = false; },

    randomCode(len = 4) {
      const digits = '0123456789';
      const alphaNum = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
      const pool = this.alphanumeric ? alphaNum : digits;
      let out = '';
      for (let i = 0; i < len; i++) {
        out += pool[Math.floor(Math.random() * pool.length)];
      }
      return out;
    },
    generateCode() {
      this.form.login_code = this.randomCode(4);
    },

    async save() {
      if (!this.form.name.trim()) return alert('Ismni kiriting!');
      const code = (this.form.login_code || '').trim();
      if (!code || code.length < 4) return alert('Login kodi kamida 4 belgidan iborat bo\'lsin!');
      this.loading = true;
      const payload = {
        name:         this.form.name.trim(),
        position:     'Usta',
        phone_number: this.form.phone,
        salary:       Number(this.form.salary || 0),
        bonus:        Number(this.form.bonus  || 0),
        ball_summa:   Number(this.form.ball_summa  || 0),
        ball_amount:  Number(this.form.ball_amount || 0),
        login_code:   code,
      };
      try {
        if (this.form.id) {
          await axios.put(`/api/v1/staff/${this.form.id}`, payload);
        } else {
          await axios.post('/api/v1/staff', payload);
        }
        this.$emit('saved');
        this.close();
      } catch (e) {
        alert('Xatolik: ' + (e.response?.data?.message || e.message));
      } finally {
        this.loading = false;
      }
    }
  }
};
</script>

<style scoped>
.overlay {
  position: fixed;
  inset: 0;
  background: rgba(15, 23, 42, 0.45);
  z-index: 9999;
  display: flex;
  align-items: center;
  justify-content: center;
  backdrop-filter: blur(3px);
}
.modal-box {
  background: white;
  border-radius: 24px;
  width: 460px;
  max-width: 95vw;
  box-shadow: 0 24px 64px rgba(0, 0, 0, 0.18);
  display: flex;
  flex-direction: column;
  max-height: 90vh;
  overflow: hidden;
}
.modal-head {
  padding: 22px 24px 16px;
  border-bottom: 1px solid #f1f5f9;
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.modal-title { margin: 0; font-size: 18px; font-weight: 800; color: #1e293b; }
.close-btn {
  background: #f1f5f9; border: none;
  width: 34px; height: 34px; border-radius: 50%;
  font-size: 22px; cursor: pointer; color: #64748b;
  display: flex; align-items: center; justify-content: center;
}
.modal-body {
  padding: 20px 24px;
  overflow-y: auto;
  display: flex;
  flex-direction: column;
  gap: 16px;
}
.modal-foot {
  padding: 16px 24px;
  border-top: 1px solid #f1f5f9;
  display: flex;
  gap: 10px;
}
.field-group { display: flex; flex-direction: column; gap: 6px; }
.flabel { font-size: 12px; font-weight: 700; color: #64748b; text-transform: uppercase; letter-spacing: 0.3px; }
.finput {
  height: 44px;
  border: 1.5px solid #e2e8f0;
  border-radius: 12px;
  padding: 0 14px;
  font-size: 14px;
  font-weight: 600;
  color: #1e293b;
  outline: none;
  transition: 0.2s;
  width: 100%;
  box-sizing: border-box;
}
.finput:focus { border-color: #5850ec; box-shadow: 0 0 0 3px rgba(88,80,236,0.1); }
.field-row-2 { display: grid; grid-template-columns: 1fr 1fr; gap: 12px; }
.btn-cancel-m {
  flex: 1; height: 46px;
  background: #f1f5f9; color: #64748b;
  border: none; border-radius: 14px;
  font-weight: 700; cursor: pointer;
}
.btn-save-m {
  flex: 2; height: 46px;
  background: linear-gradient(135deg, #5850ec, #4338ca);
  color: white; border: none; border-radius: 14px;
  font-weight: 800; cursor: pointer;
  transition: 0.2s;
}
.btn-save-m:disabled { opacity: 0.6; }

/* Login kodi */
.label-row { display: flex; justify-content: space-between; align-items: center; }
.alpha-toggle {
  display: flex; align-items: center; gap: 6px;
  font-size: 11px; font-weight: 600; color: #475569;
  cursor: pointer; user-select: none;
}
.alpha-toggle input { cursor: pointer; }
.code-row {
  display: flex; gap: 8px;
}
.code-input {
  flex: 1;
  letter-spacing: 2px;
  font-family: 'JetBrains Mono', 'Consolas', monospace;
  font-weight: 800;
}
.btn-gen {
  height: 44px; padding: 0 14px;
  background: #ede9fe; color: #5850ec;
  border: 1.5px solid #a78bfa; border-radius: 12px;
  font-weight: 800; font-size: 13px; cursor: pointer;
  white-space: nowrap;
  transition: 0.15s;
}
.btn-gen:hover { background: #5850ec; color: white; border-color: #5850ec; }
.code-hint {
  font-size: 12px; color: #64748b;
  background: #f1f5f9; padding: 6px 10px; border-radius: 8px;
  margin-top: 4px;
}
.code-hint b { color: #5850ec; letter-spacing: 1.5px; }

/* Ball card */
.ball-card {
  background: linear-gradient(135deg, #fef3c7, #fde68a);
  border: 1.5px solid #fbbf24;
  border-radius: 14px;
  padding: 14px;
  display: flex;
  flex-direction: column;
  gap: 10px;
}
.ball-title { font-weight: 800; color: #92400e; font-size: 14px; }
.ball-help { font-size: 12px; color: #78350f; }
.ball-help b { color: #92400e; }
.ball-off { color: #b91c1c; font-weight: 700; margin-left: 4px; }
</style>
